import {
  Accommodation,
  Insurance,
  PremiumResidence,
  PrivateLesson,
  ProfessionalImmersionExperience,
  SchoolSupplement,
  Transfer,
  TransferServiceType,
} from '@lx/shared/data-access/products';
import { PremiumActivity } from '@lx/shared/data-access/school';

export interface SchoolExtras {
  accommodations?: Accommodation[];
  accommodationOptional?: boolean;
  moreAccommodationsDisclaimerShown?: boolean;
  insurance?: Insurance;
  professionalImmersionExperience?: ProfessionalImmersionExperience;
  groupedTransfers?: Record<TransferServiceType, Transfer[]>;
  premiumAccommodation?: PremiumResidence;
  privateLesson?: PrivateLesson;
  unaccompaniedMinorServices?: SchoolSupplement[];
  premiumActivities?: PremiumActivity[];
}
